import { NumberInput, TextInput, required, minValue, ReferenceInput, AutocompleteInput } from "react-admin";
import { Grid } from "@mui/material";
import GradeThresholdsArrayInput from "./GradeThresholdsArrayInput";
import DepartmentInput from "./DepartmentInput";
import { administrationRequests } from "api/administrationApi";

const SaveForm = ({ isEdit = false }) => {
  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          lg={4}
          md={5}
          sm={7}
          xs={12}
        >
          <TextInput
            label="Име"
            source="name"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          lg={2}
          md={3}
          sm={5}
          xs={12}
        >
          <NumberInput
            label="Макс. точки"
            source="maxPoints"
            step={1}
            validate={[required(), minValue(1)]}
            parse={value => (value ? parseInt(value, 10) : "")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
        >
          <ReferenceInput
            source="directionId"
            filter={{ filterByUser: true }}
            reference={administrationRequests.getDirectionsSelect()}
          >
            <AutocompleteInput
              validate={[required()]}
              label="Направление"
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              readOnly={isEdit}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
        >
          <DepartmentInput readOnly={isEdit} />
        </Grid>
      </Grid>

      <Grid container>
        <Grid
          item
          lg={6}
          md={8}
          sm={12}
        >
          <GradeThresholdsArrayInput />
        </Grid>
      </Grid>
    </>
  );
};

export default SaveForm;
